/* eslint-disable */
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when the `authState` could not be initialised
 * @export
 * @class AuthCouldNotInitStateError
 * @extends {Error}
 */
export class AuthCouldNotInitStateError extends Error {
  /**
   * Creates an instance of AuthCouldNotInitStateError
   * @param {string} message The Error `message`
   * @memberof AuthCouldNotInitStateError
   */
  constructor(message) {
    super(message);
    this.name = `AuthCouldNotInitStateError`;
  }
}

/**
 * Called when the `authState` could not be initialised
 * @param {Error} error The caught Error
 * @returns {never} never
 */
const throwAuthCouldNotInitStateError = (error) => {
  throw new AuthCouldNotInitStateError(
    stripIndent(`
    Could not initialise auth state

    Experienced:
    ${error.stack}
    `),
  );
};

export default throwAuthCouldNotInitStateError;
